import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const ROWS = [
    { nm: 'Northwind Ltd', badge: 'gold', label: 'Gold', pct: '82%', pctCls: 'g' },
    { nm: 'Atlas Bio', badge: 'silver', label: 'Silver', pct: '61%', pctCls: 'a' },
    { nm: 'Cedar Labs', badge: 'bronze', label: 'Bronze', pct: '48%', pctCls: 'a' },
];

const AngelHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge" data-lp-reveal><span />For angel networks</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Your network becomes the quality standard.</h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">The first network to deliver pre-diligenced companies will set the bar. Free to the network. No friction for your applicants. Diligence tools for your angels.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a 20-min demo</a>
                    <a className="lp-btn lp-btn--ghost" href="#how-it-works">See how it works ↓</a>
                </div>
                <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span className="d" style={{ width: 7, height: 7, borderRadius: '50%', background: '#FC7785', display: 'inline-block' }} />
                    Free to angel networks · No IT setup · Starts in days
                </div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-hero-stage lp-hero-stage--angel">
                    <div className="lp-hero-panel" aria-hidden="true" />
                    <img className="lp-hero-photo" src={require('../../../../images/landing-pages/angel-networks/angel-networks-top-banner.png')} alt="Angel network partner" />
                    <div className="lp-hero-dash lp-float" data-lp-reveal data-lp-delay="200">
                        <div className="lp-dash-top">
                            <div className="t">Applicant dashboard</div>
                            <div className="lp-dash-ring">
                                <svg width="62" height="62" viewBox="0 0 62 62" aria-hidden="true">
                                    <circle cx="31" cy="31" r="26" fill="none" stroke="#EAF6EF" strokeWidth="7" />
                                    <circle cx="31" cy="31" r="26" fill="none" stroke="#1F8A5B" strokeWidth="7" strokeLinecap="round" strokeDasharray="163.4" strokeDashoffset="29.4" />
                                </svg>
                                <div className="p">82%</div>
                            </div>
                        </div>
                        <div className="lp-dash-rows">
                            {ROWS.map((r, i) => (
                                <div className="lp-dash-row" key={i}>
                                    <span className="nm">{r.nm}</span>
                                    <span className="rt">
                                        <span className={`badge ${r.badge}`}>{r.label}</span>
                                        <span className={`pct ${r.pctCls}`}>{r.pct}</span>
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="lp-hero-pill lp-float">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                        Pre-diligenced
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AngelHeroSection;
